import firebase from 'firebase'

import { KeyofTypeofNotifyAbout } from 'UI/Routes/notification/PageNotifications'

type ReactionRefProps = {
    uid: string
    playbookId: string
}

const reactionRef = ({ uid, playbookId }: ReactionRefProps) =>
    firebase.database().ref(`/playbookReactions/${uid}/${playbookId}/reaction`)

const usersRef = (uid: string) => firebase.firestore().doc(`users/${uid}`)

const usersPerOrgRef = (orgId: string) =>
    firebase.firestore().collection(`usersPerOrg/${orgId}/users`)

type SetUserReactionType = {
    uid: string
    playbookId: string
    reaction: number
    result?: number | null
}

export const setUserReaction = ({
    uid,
    playbookId,
    reaction,
    result = null
}: SetUserReactionType) =>
    reactionRef({ playbookId, uid }).set({
        reaction,
        result,
        lastEdited: firebase.database.ServerValue.TIMESTAMP
    })

export const getUserByEmail = (orgId: string, email: string) =>
    usersPerOrgRef(orgId)
        .where('email', '==', email)
        .limit(1)
        .get()
        .then(res => ({ ...res.docs?.[0]?.data() }))
        .catch(console.error)

type UpdateUserProfileType = {
    uid: string
    displayName: string
    organizationRole: {
        roleId: string
        roleName: string
    }
}

export const updateUserProfile = ({ uid, displayName, organizationRole }: UpdateUserProfileType) =>
    usersRef(uid).update({ displayName, organizationRole }).catch(console.error)

type UpdateUserOrgRoleType = {
    uid: string
    organizationRole: number
}

export const updateUserOrgRole = ({ uid, organizationRole }: UpdateUserOrgRoleType) =>
    usersRef(uid).update({ organizationRole }).catch(console.error)

type UpdateUserType = {
    uid: string
    payload: {
        englishFlavor?: string
        secondaryLanguage?: string
        'notificationSettings.notifyVia'?: Array<string>
        'notificationSettings.notifyAbout'?: Record<KeyofTypeofNotifyAbout, boolean>
    }
}
export const updateUser = ({ uid, payload }: UpdateUserType) =>
    usersRef(uid).update(payload).catch(console.error)

type SetUserAchievementProps = Partial<{
    initialDesiredPlan: string
    referralSource: string
    oneDriveConnected: string
}>

export const setUserAchievement = (uid: string, payload: SetUserAchievementProps) => {
    return firebase
        .firestore()
        .doc(`userAchievements/${uid}`)
        .set(payload, { merge: true })
        .catch(console.error)
}

export const setOnboardingFinished = (uid: string, value: boolean) => {
    return firebase
        .database()
        .ref(`postOnboarding/${uid}/isProgressBarShown`)
        .set(value)
        .catch(console.error)
}
